import React, { Component } from "react";
import axios from 'axios';
import { logout } from "./../components/auth/UserFunctions";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  FormInput,
  Button
} from "shards-react";
import { matchPath } from 'react-router'
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import api from '../components/common/api';

class ChangePassword extends Component{

  constructor(){
    super()
    this.state = {
      password:'',
      repeatPassword:'',
      errors:false
    }

  }

  async componentDidMount(){

  }

  onChange = e => {
    this.setState({[e.target.id]: e.target.value})
  }

  onSubmit = e => {
    e.preventDefault();
    this.changePassword();
  }

  handleAccept = (e) =>{
    e.preventDefault();
    if (this.state.errors){
      this.setState({dialogOpen: false, message: '', errors: false})
    } else {
      logout()
    }
  }

  changePassword(){
      var formData = new FormData();
      formData.set("email", localStorage.getItem('userEmail'));
      formData.set("password", this.state.password);
      formData.set("new_password", this.state.new_password);
      formData.set("confirm_password", this.state.confirm_password);
      const token = localStorage.getItem('userToken')
      var self = this
      axios.post(api.changePassword,
        formData,
        {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
         )
        .then((response)=> {
          self.setState({message: 'Se ha cambiado la contraseña con éxito!', dialogOpen: true, errors: false})
        })
        .catch(error => {
          var promise = new Promise(function(resolve, reject) {
          resolve(error.response);
          var a  = error.response
          if (a.data.errors){
            if (a.status_code !== 404){
              var keys = Object.keys(a.data.errors); 
              var errors = ''
              for(var i = 0; i < keys.length; i++) {   
                var key = (keys[i]) ; 
                var key_errors = a.data.errors[key]
                key_errors.map((val,idx)=>{
                  errors = errors + ' ' + val
                })
              }
              self.setState({message: errors, dialogOpen: true, errors: true})
            } else {
              self.setState({message: 'La contraseña ingresada es incorrecta!',dialogOpen: true, errors: true})
            }
          }

          });
      })
  }

  render (){

    return (
    <Container fluid className="main-content-container h-100 px-4">
      <Row noGutters className="h-100">
        <Col lg="3" md="5" className="auth-form mx-auto my-auto">
          <Card>
            <CardBody>
              {/* Logo */}
                <img
                  className="auth-form__logo d-table mx-auto mb-3"
                  src={require("../images/logoautocorp.png")}
                  alt="Shards Dashboards - Login Template"
                />

              <h5 className="auth-form__title text-center mb-4">
                Cambiar contraseña
              </h5>

              <Form onSubmit={this.onSubmit}>
                <Dialog
                  open={this.state.dialogOpen}
                  fullWidth
                  aria-labelledby="responsive-dialog-title"
                >
                  <DialogTitle id="responsive-dialog-title">{"Cambio de contraseña"}</DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                        {this.state.message}
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions disableSpacing="false">  
                    <Button onClick={(e)=>{this.handleAccept(e)}} variant="contained" color="primary" >
                        Aceptar
                    </Button>
                  </DialogActions>
                </Dialog>
                <FormGroup>
                  <label htmlFor="exampleInputPassword1">Contraseña actual</label>
                  <FormInput
                    type="password"
                    invalid={this.state.error}
                    id="password"
                    name="password"
                    value={this.state.password}
                    onChange={this.onChange}
                    placeholder="Contraseña"
                    autoComplete="new-password"
                  />
                </FormGroup>
                <FormGroup>
                  <label htmlFor="exampleInputPassword1">Nueva Contraseña</label>
                  <FormInput
                    type="password"
                    invalid={this.state.error}
                    id="new_password"
                    name="new_password"
                    value={this.state.new_password}
                    onChange={this.onChange}
                    placeholder="Contraseña"
                    autoComplete="new-password"
                  />
                </FormGroup>
                <FormGroup>
                  <label htmlFor="exampleInputPassword2">Repetir contraseña</label>
                  <FormInput
                    type="password"
                    id="confirm_password"
                    invalid={this.state.error}
                    name="confirm_password"
                    value={this.state.confirm_password}
                    onChange={this.onChange}
                    placeholder="Repetir contraseña"
                    autoComplete="new-password"
                  />
                </FormGroup>
                {(this.state.error) ? <label style={{color:"red"}}>{this.state.error}</label> :''}

                <Button
                  pill
                  theme="accent"
                  className="d-table mx-auto"
                  type="submit"
                >
                  Cambiar contraseña
                </Button>

              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
    )
  } 
}

export default ChangePassword;
